import React from "react";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import classNames from "classnames";
import { Container } from "react-bootstrap";
import NavBar from "./Navbar";
import Dashboard from "../../pages/Dashboard";
import Branches from "../../pages/Branches";
import Manager from "../../pages/Manager";
import SingleBranch from "../../pages/SingleBranch";
import SingleManager from "../../pages/SingleManager";
import SingleAssistants from "../../pages/SingleAssistants";
import SinglePods from "../../pages/SinglePods";
import SinglePodMember from "../../pages/SinglePodMember";
import Assistants from "../../pages/Assistants";
import Pods from "../../pages/Pods";
import MicrosoftProtectedRoute from "../MicrosoftProtectedRoute"; 
import Login from "../../pages/Login";

class Content extends React.Component {
  
  getPageTitle = () => {
    const pathname = window.location.pathname;
    
    switch(pathname) {
      case '/dashboard':
        return 'Dashboard';
      case '/branches':
        return 'Branches';
      case '/manager':
        return 'Managers';
      case '/assistants':
        return 'Assistants';
      case '/teams_pods':
        return 'Pods/Teams';
      default:
        if (pathname.includes('/branches/singlebranch/')) return 'Branch Details';
        if (pathname.includes('/manager/singlemanager/')) return 'Manager Details';
        if (pathname.includes('/assistants/singleassistant/')) return 'Assistant Details';
        if (pathname.includes('/teams_pods/singlepods/')) return 'Pod Details';
        if (pathname.includes('/teams_pods/singlepodmember/')) return 'Pod Member Details';
        return 'Dashboard';
    }
  };

  render() {
    return (
      <Container
        fluid
        className={classNames("content bg-FEFAF6 p-0 m-0", { 
          "is-open": !this.props.isLoginPage && this.props.isOpen,
          "is-collapsed": !this.props.isLoginPage && this.props.isCollapsed
        })}
      >
        {!this.props.isLoginPage && (
          <NavBar 
            toggle={this.props.toggle} 
            isCollapsed={this.props.isCollapsed}
            pageTitle={this.getPageTitle()}
          />
        )}
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/login" element={<Navigate to="/login" replace />} />
          <Route path="/" element={<Login />} />

          <Route path="/dashboard" element={
            <MicrosoftProtectedRoute>
              <Dashboard />
            </MicrosoftProtectedRoute>
          } />
          <Route path="/branches" element={
            <MicrosoftProtectedRoute>
              <Branches />
            </MicrosoftProtectedRoute>
          } />
          <Route path="/manager" element={
            <MicrosoftProtectedRoute>
              <Manager />
            </MicrosoftProtectedRoute>
          } />
          <Route path="/branches/singlebranch/:id" element={
            <MicrosoftProtectedRoute>
              <SingleBranch />
            </MicrosoftProtectedRoute>
          } />
          <Route path="/manager/singlemanager/:id" element={
            <MicrosoftProtectedRoute>
              <SingleManager />
            </MicrosoftProtectedRoute>
          } />
          <Route path="/assistants/singleassistant/:id" element={
            <MicrosoftProtectedRoute>
              <SingleAssistants />
            </MicrosoftProtectedRoute>
          } />
          <Route path="/teams_pods/singlepods/:id" element={
            <MicrosoftProtectedRoute>
              <SinglePods />
            </MicrosoftProtectedRoute>
          } />
          <Route path="/teams_pods/singlepodmember/:id/:type" element={
            <MicrosoftProtectedRoute>
              <SinglePodMember />
            </MicrosoftProtectedRoute>
          } />
          <Route path="/assistants" element={
            <MicrosoftProtectedRoute>
              <Assistants />
            </MicrosoftProtectedRoute>
          } />
          <Route path="/teams_pods" element={
            <MicrosoftProtectedRoute>
              <Pods />
            </MicrosoftProtectedRoute>
          } />
        </Routes>
      </Container>
    );
  }
}

export default Content;
